
import { defineComponent, type PropType } from 'vue'
import { IdfIcon, IdfProgressBar } from '@invivodf/ui-kit'

export type QuotaProgress = {
  label?: string
  remaining?: number
  initial?: number
  meterText?: string
  initialQuota?: string
}

/**
 * Remplacement local d'`IdfQuotaProgress` (@b2ag/design-system), bâti sur `IdfProgressBar`.
 *
 * Écart assumé avec `MMeter`, la jauge du design system : celle-ci affichait « Restant : X » à
 * l'intérieur de la barre, en la déplaçant à l'extérieur sous 50 %. `IdfProgressBar` n'accepte
 * pas de contenu ; le texte est donc placé sous la barre, à droite.
 * L'icône `adn-icon--category-stock` (rayonnage) n'a pas d'équivalent dans ui-kit 0.200 :
 * `scale-outlined` la remplace, sur le registre de la quantité.
 */
export default defineComponent({
  name: 'PQuotaProgress',
  components: { IdfIcon, IdfProgressBar },
  props: {
    quota: {
      type: Object as PropType<QuotaProgress>,
      required: true,
    },
  },
  computed: {
    progression(): string {
      const { remaining = 0, initial = 0 } = this.quota
      if (!initial) return '0'
      return String(Math.min(100, Math.max(0, (remaining * 100) / initial)))
    },
  },
})
